import React from "react";

export default function Header({name, visible, onClick} ){
    let claz = "listHeader";
    if( !visible )
        claz += " unselected"
    function click(){
        onClick(name);
    }
    return         <span onClick={click} className={claz}>{name}</span>
}